import type { CourseType } from 'bundles/enterprise-legacy-learner-home/utils/courseTypeMetadataUtils';

export type GuestCheckoutEligibilityProps = {
  isSpecialization?: boolean;
  s12nId?: string;
  courseId?: string;
  course?: { s12nIds?: Array<string> };
  courseType?: CourseType;
};

const EXCLUDED_COURSE_TYPES: Array<CourseType> = ['GuidedProject', 'Project'];

export const isGuestCheckoutEligibleProduct = ({
  isSpecialization,
  s12nId,
  courseId,
  course,
  courseType,
}: GuestCheckoutEligibilityProps): boolean => {
  // Same `onSdp` rule as withEnrollModal's enrollModalProps; covers Specializations, Professional and Gateway Certificates.
  if (isSpecialization && s12nId) return true;
  if (!courseId) return false;
  if (courseType && EXCLUDED_COURSE_TYPES.includes(courseType)) return false;
  return (course?.s12nIds?.length ?? 0) > 0;
};

export default isGuestCheckoutEligibleProduct;
